import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { applyOptIn, applyOptInOutManager, applyOptOut } from ".";
import { OPT_IN_ALL_EVENT } from "../events";
import { ready } from "../utils";
/**
 * Apply cookies on frontend. Depending on some other mechanism you can differ
 * between the following "decision" types:
 *
 * - `all`: All cookies are applied (e. g. bots)
 * - `consent`: All cookies from the current consent (read from cookie)
 *
 * The cookies are sent in the following way:
 *
 * 1. Apply opt-in scripts (sequentially)
 * 2. If GTM / MTM is active, wait for the data layer
 *   a) Push all opt-in events (parallel)
 *   b) Wait x seconds to avoid side effects
 *   c) Push all opt-out events (parallel)
 * 3. Apply opt-in scripts (sequentially)
 *
 * @param type
 * @see https://www.simoahava.com/analytics/notify-page-google-tag-manager-loaded/
 * @see https://support.google.com/tagmanager/answer/7679219
 * @see https://developer.matomo.org/guides/tagmanager/datalayer
 */

function apply(_x) {
  return _apply.apply(this, arguments);
}

function _apply() {
  _apply = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(options) {
    var _yield$applyOptIn, dataLayerPromise, isManagerOptOut, cookies, applyOptInReady, _yield$applyOptInOutM, applyOptInOutManagerReady, optInAllReady;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return ready();

          case 2:
            _context.next = 4;
            return applyOptIn(options);

          case 4:
            _yield$applyOptIn = _context.sent;
            dataLayerPromise = _yield$applyOptIn.dataLayerPromise;
            isManagerOptOut = _yield$applyOptIn.isManagerOptOut;
            cookies = _yield$applyOptIn.cookies;
            applyOptInReady = _yield$applyOptIn.ready;
            _context.t0 = applyOptInOutManager;
            _context.t1 = options;
            _context.next = 13;
            return dataLayerPromise;

          case 13:
            _context.t2 = _context.sent;
            _context.t3 = isManagerOptOut;
            _context.next = 17;
            return (0, _context.t0)(_context.t1, _context.t2, _context.t3);

          case 17:
            _yield$applyOptInOutM = _context.sent;
            applyOptInOutManagerReady = _yield$applyOptInOutM.ready;
            optInAllReady = Promise.all([applyOptInReady, applyOptInOutManagerReady]);
            document.dispatchEvent(new CustomEvent(OPT_IN_ALL_EVENT, {
              detail: {
                cookies: cookies,
                ready: optInAllReady
              }
            })); // Do opt-out

            _context.next = 23;
            return applyOptOut(options, isManagerOptOut);

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _apply.apply(this, arguments);
}

export { apply };